import React from 'react';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { Add } from '@material-ui/icons';
// Components
import App from '../../../../components/app';
import ErrorMessage from '../../../../components/error-message';
import MyLink from '../../../../components/mylink/mylink';
import { TooltipButton } from '../../../../components/tooltip-button';
import { Dialog } from '../../../../components/dialog';
import Listing from '../../../../components/listing';
import ButtonTo from '../../../../components/buttonTo';
// Modules
import { ErrorPayload, selectors as errorSelectors } from '../../../../redux/reducers/errors';
import { actions as pricingActions, selectors as pricingSelectors } from '../../../../redux/reducers/pricing';
import { Extra } from '../../../../redux/reducers/api-types';
// Ressources
import withGlobalStyles from '../../../../utils/global-styles';
import UserUtils, { AccountRight, RightRank } from '../../../../utils/userUtils';
import { paths } from '../../../paths';
import { clsx } from '../../../../utils/htmlUtils';

interface FeesListProps extends WithTranslation {
    globalClasses: any;
    extras: Extra[];
    getFeesListError: ErrorPayload;
    getExtras: () => void;
    deleteExtras: (id: string) => void;
}

interface FeesListState {}

const MANAGE_FEES = paths.pricingManageFeesAdd;

class PricingFeesListPage extends React.Component<FeesListProps, FeesListState> {
    isAdmin: boolean;

    constructor(props) {
        super(props);
        this.isAdmin = UserUtils.checkRightsOrAdmin({ name: AccountRight.PRICING_MGMT, mode: RightRank.W });
    }

    componentDidMount() {
        this.props.getExtras();
    }

    handleDelete = (index, obj: Extra) => (e) => {
        if (obj.id) {
            this.props.deleteExtras(obj.id);
        } else {
            console.error("Can't delete", obj);
        }
    };

    renderExtras = (): JSX.Element => {
        const { t, extras, globalClasses } = this.props;
        return (
            <Listing
                datas={extras?.map((extra, index) => {
                    const to = `${MANAGE_FEES}?id=${extra.id}`;
                    return (
                        <div key={extra.id} style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
                            <MyLink style={{ flex: 1 }} color="secondary" to={to}>
                                {`${extra.id}`}
                            </MyLink>
                            <MyLink style={{ flex: 1 }} color="secondary" to={to}>
                                {`${extra.name}`}
                            </MyLink>
                            {this.isAdmin && (
                                <Dialog
                                    btnTitle={t('common:validate')}
                                    description={t('common:deleteParam', {
                                        id: `(${extra.id}) ${extra.name}`,
                                    })}
                                    customButton={
                                        <TooltipButton title={t('common:delete')}>
                                            <Button
                                                size="small"
                                                style={{ marginLeft: 8 }}
                                                variant="contained"
                                                color="primary"
                                                className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                                            >
                                                <Icon fontSize="small">delete</Icon>
                                            </Button>
                                        </TooltipButton>
                                    }
                                    onOK={this.handleDelete(index, extra)}
                                />
                            )}
                        </div>
                    );
                })}
            />
        );
    };

    renderFAB = (): JSX.Element => {
        const { t, globalClasses } = this.props;
        return (
            this.isAdmin && (
                <>
                    <br />
                    <br />
                    <Fab
                        className={globalClasses.fabBotRight}
                        size="large"
                        component={RouterLink}
                        to={`${MANAGE_FEES}`}
                        color="secondary"
                        aria-label={t('common:add')}
                    >
                        <AddIcon />
                    </Fab>
                </>
            )
        );
    };

    render() {
        const { t, extras, getFeesListError } = this.props;

        return (
            <App
                needRights={AccountRight.PRICING_MGMT}
                header={{
                    title: t('fees.title'),
                    button: (
                        <ButtonTo
                            rights={{ name: AccountRight.PRICING_MGMT, mode: RightRank.W }}
                            startIcon={<Add />}
                            to={MANAGE_FEES}
                            text={t('common:add')}
                        />
                    ),
                }}
            >
                <ErrorMessage payload={getFeesListError} />
                {extras && this.renderExtras()}
                {/* {this.renderFAB()} */}
            </App>
        );
    }
}

const PricingFeesListPageWithTranslation = withGlobalStyles(
    withTranslation(['pricing', 'common'])(PricingFeesListPage),
);

const mapStateToProps = (state) => ({
    extras: pricingSelectors.extras(state),
    getFeesListError: errorSelectors.getFeesListError(state),
});

const mapDispatchToProps = {
    getExtras: pricingActions.getExtras,
    deleteExtras: pricingActions.deleteExtras,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingFeesListPageWithTranslation);
